import { AwsRum } from "aws-rum-web";
import getEnvConfig from "../config";

export const getAwsRumConfig = (): AwsRum => {
  let rumEnvCfg = window.GameEnvironment.config.aws_rum_config;
  let rumAppCfg = getEnvConfig().aws_rum_application;

  if (rumEnvCfg && rumAppCfg) {
    const endpoint = rumEnvCfg.endpoint.startsWith("https://") ? rumEnvCfg.endpoint : `https://${window.location.host}${rumEnvCfg.endpoint}`;
    console.log("RUM Endpoint: " + endpoint);
    return new AwsRum(rumAppCfg.application_id, rumAppCfg.application_version, rumAppCfg.application_region, {
      endpoint: endpoint,
      signing: false,
      telemetries: rumEnvCfg.telemetries,
      allowCookies: rumEnvCfg.allow_cookies,
      enableXRay: rumEnvCfg.enable_xray,
      sessionSampleRate: rumEnvCfg.session_sample_rate,
      sessionEventLimit: rumEnvCfg.session_event_limit,
      batchLimit: 20
    })
  }

  throw new Error("No Aws Rum configuration found for host: " + window.location.host);
}